// extracted by mini-css-extract-plugin
export default {"text":"text_2rPFs","input":"input_SlZ5e","answer":"answer_19XhH"};